import { ref, watch } from 'vue';

export const MAX_TILT = 45;

export const useTiltController = (map) => {
    const tilt = ref(MAX_TILT);

    watch(tilt, () => {
        if (map.value) {
            try {
                map.value.setTilt(tilt.value);
            } catch (error) {
                console.error('Error setting map tilt:', error);
            }
        }
    });

    return { tilt };
};
